<script>
  import SectionTitle from "../../../components/layout/SectionTitle.svelte";
  import Section from "../../../components/layout/Section.svelte";
  import { useInvalidateLicenseData, useLicenseData } from "../../../hooks/license/useLicenseData.js";
  import { translate } from "../../../i18n/i18next.js";
  import ManageLicenseAuthenticationDialog from "./ManageLicenseAuthenticationDialog/index.svelte";
  import Loading from "../../../components/pages/Loading.svelte";
  import GeneralButton from "../../../components/button/GeneralButton.svelte";
  import Alert from "../../../components/Alerts/Alert.svelte";
  import InitEProtectorLicenseAuthenticationDialog from "./InitEProtectorLicenseAuthenticationDialog/index.svelte";
  import ChangeLicenseAuthenticationMethodDialog
    from "./ChangeLicenseAuthenticationMethodDialog/ChangeLicenseAuthenticationMethodDialog.svelte";
  import Button from "../../../components/button/Button.svelte";
  import EProtectorStatusAlert from "../../../components/licensing/EProtectorStatusAlert.svelte";
  import { getNotificationsContext } from "svelte-notifications"
  import LicenseSectionMySchedule from "./LicenseSectionMySchedule.svelte";
  import LicenseSectionWs from "./LicenseSectionWs.svelte";

  const licenseData = useLicenseData()
  const {addNotification} = getNotificationsContext()
  const {invalidateLicenseData} = useInvalidateLicenseData()

  let isManageLicenseAuthenticationDialogOpen = false

  let openedDialog = null

  async function onClickInitEProtector() {
    try {
      const eProtectorStatusResponse = await fetch("/api/license/e-protector")
      const eProtectorStatusResponseData = await eProtectorStatusResponse.json().catch(() => null)
      if (eProtectorStatusResponse.ok && eProtectorStatusResponseData?.validityPeriod?.isValid?.ok) {
        const useEProtectorResponse = await fetch("/api/license/e-protector/use", {method: "POST"})
        if (useEProtectorResponse.ok) {
          addNotification({
            position: "top-right",
            type: "success",
            removeAfter: 4000,
            text: translate("frontend:components.applyLicenseFileDialog.messages.haspEnabled")
          })
          await invalidateLicenseData()
          return
        }
      }
      openedDialog = "initEProtector"
    } catch (e) {
      console.log(e)
    }
  }
</script>

{#if $licenseData}
  {#if $licenseData.authMethod === "none"}
    <Alert type="info">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap; width: 100%">
        {translate("frontend:pages.admin.server.sections.license.initAuthentication.label")}
        <div style="display: flex; justify-content: end; gap: 2rem">
          <GeneralButton onClick={() => onClickInitEProtector()} type="primary">
            {translate("generic.license.protectors.eProtector")}
          </GeneralButton>
          <GeneralButton onClick={() => openedDialog = "initOnline"} type="primary">
            {translate("generic.license.protectors.online")}
          </GeneralButton>
        </div>
      </div>
    </Alert>
    {#if openedDialog === "initEProtector"}
      <InitEProtectorLicenseAuthenticationDialog onClose={() => openedDialog = null} />
    {/if}
    {#if openedDialog === "initOnline"}
      <ChangeLicenseAuthenticationMethodDialog
        currentPage="configureOnlineLicense"
        onClose={() => openedDialog = null}
      />
    {/if}
  {/if}
  {#if $licenseData.authMethod === "invalidEProtector"}
    <EProtectorStatusAlert />
  {/if}
  <Section>
    <SectionTitle>
      <div style="display: flex; justify-content: space-between">
        <span>{translate("frontend:pages.admin.server.sections.license.title")}</span>
        {#if licenseData.authMethod !== "none"}
          <Button type="secondary" onClick={() => isManageLicenseAuthenticationDialogOpen = true} style="display: inline-flex; gap: .5rem">
            <img src="/assets/icons/icon_setting_inactive.png" alt="settings icon" style="height: 1rem"/>
            {translate("frontend:pages.admin.server.sections.license.manage")}
          </Button>
        {/if}
      </div>
    </SectionTitle>
    {#if $licenseData.moduleType === "WS"}
      <LicenseSectionWs licenseData={$licenseData} />
    {:else}
      <LicenseSectionMySchedule licenseData={$licenseData} />
    {/if}
  </Section>
{:else}
  <Loading height="600px" />
{/if}

{#if isManageLicenseAuthenticationDialogOpen}
  <ManageLicenseAuthenticationDialog
    onClose={() => isManageLicenseAuthenticationDialogOpen = false}
  />
{/if}
